// extracted by mini-css-extract-plugin
export default {"subjectsEdit":"subjects-list_subjectsEdit__TrX6X","subjectsEditContent":"subjects-list_subjectsEditContent__G5iZs","skeletonSubjectsList":"subjects-list_skeletonSubjectsList__izQPm"};